import React from "react";
import { Box, Typography, Radio, Checkbox } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";

const VARIANT_STYLE = {
  enabled: {
    background: "#fff",
    border: "1.5px solid #dedede",
    color: "#601350",
  },
  hovered: {
    background: "#f3f3f3",
    border: "1.5px solid #dedede",
    color: "#601350",
  },
  selected: {
    background: "#f8f3fa",
    border: "1.5px solid #a05eb5",
    color: "#601350",
  },
  completed: {
    background: "#f3f3f3",
    border: "1.5px solid #dedede",
    color: "#bdbdbd",
  },
};

const ExpandedRadioButton = ({
  variant = "enabled",
  headline = "Headline",
  description = "Description",
  noContent = false,
  node,
  ...props
}) => {
  const style = VARIANT_STYLE[variant] || VARIANT_STYLE.enabled;
  console.log("====================================");
  console.log(node);
  console.log("====================================");
  return (
    <Box
      sx={{
        background: style.background,
        border: style.border,
        borderRadius: 2,
        minHeight: 56,
        px: 2,
        py: 1.5,

        color: style.color,
        boxShadow: "none",
        width: "100%",
        gap: 1,
        ...node?.style,
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
      }}
      {...props}
    >
      {variant === "completed" ? (
        <Checkbox
          checked
          icon={<CheckIcon sx={{ color: "#bdbdbd", fontSize: 22 }} />}
          checkedIcon={<CheckIcon sx={{ color: "#bdbdbd", fontSize: 22 }} />}
          sx={{ p: 0, mr: 1, pointerEvents: "none",...node?.chk1?.style }}
          disableRipple
        />
      ) : (
        <Radio
          checked={variant === "selected"}
          sx={{
            color: variant === "selected" ? "#7a2a6a" : "#bdbdbd",
            p: 0,
            mr: 1,
            "&.Mui-checked": {
              color: "#7a2a6a",
            },
            pointerEvents: "none",
            ...node?.rdb1?.style,
          }}
          disableRipple
        />
      )}
      <Box sx={{ flex: 1 }}>
        <Typography
          variant="body1"
          sx={{
            color: style.color,
            fontWeight: variant === "selected" ? 600 : 500,
            fontSize: 16,
            mb: noContent ? 0 : 0.5,
            ...node?.str1?.style,
          }}
        >
          {node?.str1?.label || headline}
        </Typography>
        {!noContent && (
          <Typography
            variant="body2"
            sx={{
              color: variant === "completed" ? "#bdbdbd" : "#83727c",
              fontSize: 14,
              ...node?.str2?.style,
            }}
          >
            {node?.str2?.label || description}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default ExpandedRadioButton;
